import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";

const PushapiFactorTable = ({ report, onSortChange }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} />));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('affid')}>Affid</th>
                    <th onClick={() => onSortChange('subid')}>Subid</th>
                    <th onClick={() => onSortChange('country')}>Country</th>
                    <th onClick={() => onSortChange('cost')}>Cost</th>
                    <th onClick={() => onSortChange('revenue')}>Revenue</th>
                    <th onClick={() => onSortChange('roi')}>Roi</th>
                    <th onClick={() => onSortChange('factor')}>Factor</th>
                    <th onClick={() => onSortChange('lastFactor')}>Last Factor</th>
                    <th onClick={() => onSortChange('adjustment')}>Adjustment</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default PushapiFactorTable;


// WEBPACK FOOTER //
// ./src/scenes/AdkBidFactor/components/Table/index.js